module.exports = __webpack_public_path__ + "static/media/STM.9f1c9c7f.png";